const CampaignAnalysisChartCard = ({
  title,
  headerAction = null,
  children,
  className = "",
}) => (
  <div className={`campaign-analysis-card ${className}`.trim()}>
    <div className="campaign-analysis-card__header">
      <h3 className="campaign-analysis-card__title">{title}</h3>
      {headerAction ? (
        <div className="campaign-analysis-card__header-action">
          {headerAction}
        </div>
      ) : null}
    </div>
    {children}
  </div>
);

export default CampaignAnalysisChartCard;
